/**
 * @todo: This one needs some work, as detailed in the comments within this composable.
 */
export function useTranslation() {
    function __t(key: string, values: object = {}): string {
        // @ts-ignore TODO: REMOVE THIS HACK
        let translation = window.$t(key, values);

        // @ts-ignore // TODO: remove this @ts-ignore
        if (typeof translation_variables !== "undefined" && translation_variables !== null) {
            // @ts-ignore // TODO: remove this @ts-ignore
            Object.keys(translation_variables).forEach((translationKey) => {
                // @ts-ignore // TODO: remove this @ts-ignore
                translation = translation.replaceAll(`${translationKey}`, translation_variables[translationKey]);
            });
        }

        return translation !== "" ? translation : key;
    }

    return { __t };
}
